import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09d82b15"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal2" }
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = { class: "text-center flex-1 modal-header-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body flex-row flex-wrap" }
const _hoisted_8 = { class: "table table-borderless" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*门店:")
], -1))
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*入住天数:")
], -1))
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*BMI:")
], -1))
const _hoisted_18 = { class: "mb-1 flex-row flex-align-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 mr-2" }, "至", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"100px"} }, "菜品用换行分隔")
  ])
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*早餐:")
], -1))
const _hoisted_22 = { class: "flex-row flex-align-center mb-1" }
const _hoisted_23 = {
  class: "flex-col flex-1 mr-5",
  style: {"min-height":"100px"}
}
const _hoisted_24 = ["rows"]
const _hoisted_25 = {
  key: 1,
  class: "flex-row flex-align-center mt-2"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*午间餐:")
], -1))
const _hoisted_27 = { class: "flex-row flex-align-center mb-1" }
const _hoisted_28 = {
  class: "flex-col flex-1 mr-5",
  style: {"min-height":"100px"}
}
const _hoisted_29 = ["rows"]
const _hoisted_30 = {
  key: 1,
  class: "flex-row flex-align-center mt-2"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*午餐:")
], -1))
const _hoisted_32 = { class: "flex-row flex-align-center mb-1" }
const _hoisted_33 = {
  class: "flex-col flex-1 mr-5",
  style: {"min-height":"100px"}
}
const _hoisted_34 = ["rows"]
const _hoisted_35 = {
  key: 1,
  class: "flex-row flex-align-center mt-2"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*间餐:")
], -1))
const _hoisted_37 = { class: "flex-row flex-align-center mb-1" }
const _hoisted_38 = {
  class: "flex-col flex-1 mr-5",
  style: {"min-height":"100px"}
}
const _hoisted_39 = ["rows"]
const _hoisted_40 = {
  key: 1,
  class: "flex-row flex-align-center mt-2"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*晚餐:")
], -1))
const _hoisted_42 = { class: "flex-row flex-align-center mb-1" }
const _hoisted_43 = {
  class: "flex-col flex-1 mr-5",
  style: {"min-height":"100px"}
}
const _hoisted_44 = ["rows"]
const _hoisted_45 = {
  key: 1,
  class: "flex-row flex-align-center mt-2"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*宵夜:")
], -1))
const _hoisted_47 = { class: "flex-row flex-align-center mb-1" }
const _hoisted_48 = {
  class: "flex-col flex-1 mr-5",
  style: {"min-height":"100px"}
}
const _hoisted_49 = ["rows"]
const _hoisted_50 = {
  key: 1,
  class: "flex-row flex-align-center mt-2"
}
const _hoisted_51 = { key: 2 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*补充说明:")
], -1))
const _hoisted_53 = { class: "flex-col flex-align-center mb-1" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "用,号分隔每一个要点", -1))
const _hoisted_55 = ["rows"]
const _hoisted_56 = { key: 3 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*材料选择:")
], -1))
const _hoisted_58 = { class: "flex-col flex-align-center mb-1" }
const _hoisted_59 = { class: "mb-1" }
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = { class: "modal-footer2 flex-row-center" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "datePickerContainerId" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageUploader = _resolveComponent("ImageUploader")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.id ? '编辑' : '添加'), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "modal-header-close"
            }, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.shop) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (value, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: idx,
                          value: value.id
                        }, _toDisplayString(value.name), 9, _hoisted_12))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.item.shop]
                    ])
                  ])
                ])
              ]),
              (!_ctx.isBlue)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.days) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.item.days]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isBlue)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.bmiFrom) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.item.bmiFrom]
                        ]),
                        _hoisted_19,
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.bmiTo) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.item.bmiTo]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_20,
              _createElementVNode("tr", null, [
                _hoisted_21,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      (_ctx.isBlue)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            class: "form-control mb-2",
                            placeholder: "标题",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.zaocan.title) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.item.zaocan.title]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("textarea", {
                        rows: _ctx.isBlue ? 2 : 3,
                        class: "form-control flex-1",
                        placeholder: "内容",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.zaocan.content) = $event))
                      }, null, 8, _hoisted_24), [
                        [_vModelText, _ctx.item.zaocan.content]
                      ]),
                      (_ctx.isBlue)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              placeholder: "推荐搭配1",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.zaocan.dapei1) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.zaocan.dapei1]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control ml-2",
                              placeholder: "推荐搭配2",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.zaocan.dapei2) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.zaocan.dapei2]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_ImageUploader, {
                      src: _ctx.item.zaocan.image,
                      onUpload: _ctx.imageUpload1,
                      class: "uploader"
                    }, null, 8, ["src", "onUpload"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_26,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      (_ctx.isBlue)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            class: "form-control mb-2",
                            placeholder: "标题",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.wujiancan.title) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.item.wujiancan.title]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("textarea", {
                        rows: _ctx.isBlue ? 2 : 3,
                        class: "form-control flex-1",
                        placeholder: "内容",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.wujiancan.content) = $event))
                      }, null, 8, _hoisted_29), [
                        [_vModelText, _ctx.item.wujiancan.content]
                      ]),
                      (_ctx.isBlue)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              placeholder: "推荐搭配1",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.wujiancan.dapei1) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.wujiancan.dapei1]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control ml-2",
                              placeholder: "推荐搭配2",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.wujiancan.dapei2) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.wujiancan.dapei2]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_ImageUploader, {
                      src: _ctx.item.wujiancan.image,
                      onUpload: _ctx.imageUpload2,
                      class: "uploader"
                    }, null, 8, ["src", "onUpload"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_31,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      (_ctx.isBlue)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            class: "form-control mb-2",
                            placeholder: "标题",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.item.wucan.title) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.item.wucan.title]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("textarea", {
                        rows: _ctx.isBlue ? 2 : 3,
                        class: "form-control flex-1",
                        placeholder: "内容",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.wucan.content) = $event))
                      }, null, 8, _hoisted_34), [
                        [_vModelText, _ctx.item.wucan.content]
                      ]),
                      (_ctx.isBlue)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              placeholder: "推荐搭配1",
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.item.wucan.dapei1) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.wucan.dapei1]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control ml-2",
                              placeholder: "推荐搭配2",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.item.wucan.dapei2) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.wucan.dapei2]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_ImageUploader, {
                      src: _ctx.item.wucan.image,
                      onUpload: _ctx.imageUpload3,
                      class: "uploader"
                    }, null, 8, ["src", "onUpload"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_36,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      (_ctx.isBlue)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            class: "form-control mb-2",
                            placeholder: "标题",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.item.jiancan.title) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.item.jiancan.title]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("textarea", {
                        rows: _ctx.isBlue ? 2 : 3,
                        class: "form-control flex-1",
                        placeholder: "内容",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.item.jiancan.content) = $event))
                      }, null, 8, _hoisted_39), [
                        [_vModelText, _ctx.item.jiancan.content]
                      ]),
                      (_ctx.isBlue)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              placeholder: "推荐搭配1",
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.item.jiancan.dapei1) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.jiancan.dapei1]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control ml-2",
                              placeholder: "推荐搭配2",
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.item.jiancan.dapei2) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.jiancan.dapei2]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_ImageUploader, {
                      src: _ctx.item.jiancan.image,
                      onUpload: _ctx.imageUpload4,
                      class: "uploader"
                    }, null, 8, ["src", "onUpload"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_41,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      (_ctx.isBlue)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            class: "form-control mb-2",
                            placeholder: "标题",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.item.wancan.title) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.item.wancan.title]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("textarea", {
                        rows: _ctx.isBlue ? 2 : 3,
                        class: "form-control flex-1",
                        placeholder: "内容",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.item.wancan.content) = $event))
                      }, null, 8, _hoisted_44), [
                        [_vModelText, _ctx.item.wancan.content]
                      ]),
                      (_ctx.isBlue)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              placeholder: "推荐搭配1",
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.item.wancan.dapei1) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.wancan.dapei1]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control ml-2",
                              placeholder: "推荐搭配2",
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.item.wancan.dapei2) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.wancan.dapei2]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_ImageUploader, {
                      src: _ctx.item.wancan.image,
                      onUpload: _ctx.imageUpload5,
                      class: "uploader"
                    }, null, 8, ["src", "onUpload"])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_46,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      (_ctx.isBlue)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            class: "form-control mb-2",
                            placeholder: "标题",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.item.xiaoye.title) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.item.xiaoye.title]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("textarea", {
                        rows: _ctx.isBlue ? 2 : 3,
                        class: "form-control",
                        placeholder: "内容",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.item.xiaoye.content) = $event))
                      }, null, 8, _hoisted_49), [
                        [_vModelText, _ctx.item.xiaoye.content]
                      ]),
                      (_ctx.isBlue)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              placeholder: "推荐搭配1",
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.item.xiaoye.dapei1) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.xiaoye.dapei1]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control ml-2",
                              placeholder: "推荐搭配2",
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.item.xiaoye.dapei2) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.item.xiaoye.dapei2]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_ImageUploader, {
                      src: _ctx.item.xiaoye.image,
                      onUpload: _ctx.imageUpload6,
                      class: "uploader"
                    }, null, 8, ["src", "onUpload"])
                  ])
                ])
              ]),
              (_ctx.isBlue)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _withDirectives(_createElementVNode("textarea", {
                          rows: _ctx.isBlue ? 2 : 3,
                          class: "form-control flex-1",
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.item.detail) = $event))
                        }, null, 8, _hoisted_55), [
                          [_vModelText, _ctx.item.detail]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isBlue)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.choice, (v, idx) => {
                          return (_openBlock(), _createElementBlock("div", null, [
                            _createElementVNode("div", _hoisted_59, _toDisplayString(v.title), 1),
                            _withDirectives(_createElementVNode("textarea", {
                              rows: 3,
                              class: "form-control mb-2",
                              "onUpdate:modelValue": ($event: any) => ((v.content) = $event)
                            }, null, 8, _hoisted_60), [
                              [_vModelText, v.content]
                            ])
                          ]))
                        }), 256))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "确定")
          ])
        ]),
        _hoisted_62
      ]))
    : _createCommentVNode("", true)
}